export const initialState = {
    is_loading: true,
    details: {},
    is_sending: false,
    error: ''
}